import { render, staticRenderFns } from "./ForbiddenPage.vue?vue&type=template&id=eee2709a&scoped=true"
import script from "./ForbiddenPage.vue?vue&type=script&lang=js"
export * from "./ForbiddenPage.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenPage.vue?vue&type=style&index=0&id=eee2709a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee2709a",
  null
  
)

export default component.exports